<div class="container">
	<div class="page-header">
		<h1 class="page-title">Complaints Dashboard</h1>
	</div>

	<!-- Stats Grid -->
	<div class="stats-grid">
		<div class="stat-card">
			<div class="stat-value">{{ totalComplaints }}</div>
			<div class="stat-label">Total Complaints</div>
		</div>
		<div class="stat-card">
			<div class="stat-value">{{ withinSla }}</div>
			<div class="stat-label">Within SLA</div>
		</div>
		<div class="stat-card">
			<div class="stat-value">{{ approachingSla }}</div>
			<div class="stat-label">Approaching SLA</div>
		</div>
		<div class="stat-card">
			<div class="stat-value">{{ outOfSla }}</div>
			<div class="stat-label">Out of SLA</div>
		</div>
	</div>

	<!-- Dashboard Grid -->
	<div class="dashboard-grid">
		<!-- Pie Card -->
		<div class="dashboard-card">
			<div class="card-header">
				<h3 class="card-title">Complaints by SLA Status</h3>
			</div>

			<div class="chart-row">
				<div class="pie-chart-container">
					<canvas id="slaPieChart"></canvas>
					<div class="center-label">
						<div class="label-text">Total</div>
						<div class="total-number">{{ totalComplaints }}</div>
					</div>
				</div>

				<div class="custom-legend">
					<div class="legend-item">
						<span class="legend-color within"></span>
						<div class="legend-text">
							<div class="legend-value">{{ withinSla }}</div>
							<div class="legend-label">Within SLA</div>
							<div class="legend-percent">
								{{
									(withinSla / totalComplaints) * 100
										| number : "1.0-0"
								}}%
							</div>
						</div>
					</div>

					<div class="legend-item">
						<span class="legend-color approaching"></span>
						<div class="legend-text">
							<div class="legend-value">{{ approachingSla }}</div>
							<div class="legend-label">Approaching SLA</div>
							<div class="legend-percent">
								{{
									(approachingSla / totalComplaints) * 100
										| number : "1.0-0"
								}}%
							</div>
						</div>
					</div>

					<div class="legend-item">
						<span class="legend-color out"></span>
						<div class="legend-text">
							<div class="legend-value">{{ outOfSla }}</div>
							<div class="legend-label">Out of SLA</div>
							<div class="legend-percent">
								{{
									(outOfSla / totalComplaints) * 100
										| number : "1.0-0"
								}}%
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Resolution time Card -->
		<div class="dashboard-card">
			<div class="card-header">
				<h3 class="card-title">Average Resolution Time (Days)</h3>
			</div>
			<div class="chart-container">
				<canvas id="resolutionTimeChart"></canvas>
			</div>
		</div>

		<!-- Monthly Trend -->
		<div class="dashboard-card">
			<div class="card-header">
				<h3 class="card-title">Monthly Complaints Trend</h3>
			</div>
			<div class="chart-container">
				<canvas id="complaintsTrendChart"></canvas>
			</div>
		</div>
	</div>

	<!-- Table -->
	<div class="table-container">
		<div class="table-header">Recent Complaints Requiring Attention</div>

		<nz-table
			[nzData]="recentComplaints"
			nzSize="middle"
			nzFrontPagination="false"
			class="recent-table"
		>
			<thead>
				<tr>
					<th>ID</th>
					<th>Category</th>
					<th>Customer</th>
					<th>Priority</th>
					<th>SLA Status</th>
					<th>Days Open</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let complaint of recentComplaints">
					<td>{{ complaint.id }}</td>
					<td>{{ complaint.category }}</td>
					<td>{{ complaint.customer }}</td>
					<td>{{ complaint.priority }}</td>
					<td>
						<span
							class="badge"
							[ngClass]="{
								'text-bg-danger':  complaint.slaStatus === 'Out of SLA',
								'text-bg-warning': complaint.slaStatus === 'Approaching',
								'text-bg-success': complaint.slaStatus === 'Within SLA'}">
							{{ complaint.slaStatus }}
						</span>
					</td>
					<td>{{ complaint.daysOpen }}</td>
				</tr>
			</tbody>
		</nz-table>
	</div>
</div>
